import { render, staticRenderFns } from "./PalpationIndex.vue?vue&type=template&id=42c34a14&"
import script from "./PalpationIndex.vue?vue&type=script&lang=js&"
export * from "./PalpationIndex.vue?vue&type=script&lang=js&"
import style0 from "./PalpationIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports